import React, { lazy } from 'react';
import Loadable from '../../components/Loadable';
import { ShippingProvider } from "../../contexts/shipping/ShippingContext";

const ShippingFragment = Loadable(lazy(() => import('./views/ShippingFragment')));
const AddShippingFragment = Loadable(lazy(() => import('./views/AddShippingFragment')));
const ShippingAddress = Loadable(lazy(() => import('./views/ShippingAddress')));
const PaymentMethods = Loadable(lazy(() => import('./views/PaymentMethods')));

const shippingRoutes = [
    { path: '/shipping/add', element: <ShippingProvider><AddShippingFragment /></ShippingProvider> },
    { path: '/shipping/add/:id', element: <ShippingProvider><AddShippingFragment /></ShippingProvider> },
    { path: '/shipping/all', element: <ShippingProvider><ShippingFragment /></ShippingProvider> },
    { path: '/shipping/address', element: <ShippingProvider><ShippingAddress /></ShippingProvider> },
    { path: '/shipping/methods', element: <ShippingProvider><PaymentMethods /></ShippingProvider> },
];

export default shippingRoutes;
